import { putInstalmentRequest } from '../../../../../../resources/contract/actions';

import {
    InstalmentModalActions,
    Props as InstalmentModalActionsProps,
} from './InstalmentModalActions';

type EditInstalmentModalProps = Omit<
    InstalmentModalActionsProps,
    'title' | 'submitTextButton' | 'submitAction'
>;

export const EditInstalmentModal = (props: EditInstalmentModalProps) => {
    return (
        <InstalmentModalActions
            {...props}
            title="contract.payment_schedule.modal.title.edit"
            submitTextButton="contract.payment_schedule.modal.submit.edit"
            submitAction={putInstalmentRequest}
        />
    );
};
